import { Entity } from "src/app/core/data/schema/entity";

/**
 * Media Path
 */
export class MediaPath extends Entity {

    static className = 'MediaPath';
    static idField = 'mediaPathId';
    
    mediaPathId: number = 0;
    path: string;

    constructor(mediaPath?: Partial<MediaPath>) {
        super();
        Object.assign(this, mediaPath);
    }

    async uploadImg(base64Img: string){
        this.path = <string> await this.uploadBase64Images([base64Img], null, '' );
    }

    async uploadImgs(base64Imgs: string[]){
        this.path = <string> await this.uploadBase64Images(base64Imgs, null, '' );
    }

    // ----------------------------------------------------
    // Service-like features from here on down
    // ----------------------------------------------------


    public static async loadAll() {
        return await MediaPath.fetchArray(MediaPath);
    }
}
